import script from "./UiStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiStatCard.vue?vue&type=script&setup=true&lang=js"

import "./UiStatCard.vue?vue&type=style&index=0&id=5ec2c5bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec2c5bd"]])

export default __exports__